import type { IAssetSource } from '@monofe/util';

export interface ITextProps {
    text: string;
    fontFamily: string;
    fontSize: string;
    fontAlignment: 'left' | 'center' | 'right' | 'justify';
    fontWeight: number;
    color: string;
    visible: boolean;
    opacity: number;
}

export interface IImageProps {
    urls: IAssetSource[];
    mode: 'contain' | 'cover';
}

export enum ITourSelectType {
    Undef = 0,
    List = 1,
    GridTile = 2,
    GridFeatured = 3,
    LastValue = 4,
}

export interface ITourSelectItemViewModel {
    title: ITextProps;
    detail: ITextProps;

    topSeparatorVisible: boolean;
    topSeparatorColor: string;
    bottomSeparatorVisible: boolean;
    bottomSeparatorColor: string;

    backgroundImage: IImageProps;
    backgroundColor: string;
    cornerRadius: number;

    data?: unknown;
    onClick: string | ((item: ITourSelectItemViewModel) => void);
}

export interface IBackButtonProps {
    backgroundColor: string;
    strokeColor: string;
    strokeSize: string;
    arrowColor: string;
    visible: boolean;
}

export interface ITourSelectViewModel {
    title: ITextProps;

    backgroundColor: string;
    backgroundImage: IImageProps;

    backButton: IBackButtonProps;

    items: ITourSelectItemViewModel[];

    data?: unknown;

    onBack?: () => void;
    didScroll?: (position: { top: number; left: number }) => void;
}

export interface ITourSelectMainProps {
    model: ITourSelectViewModel;
}

export interface ITourSelectItemProps {
    model: ITourSelectItemViewModel;
}

export interface ITourSelectIndexProps {
    model: ITourSelectViewModel;
    type: ITourSelectType;
}

export type ITourSelectControllerModel = ITourSelectViewModel;
